/**
 * Loading skeleton for Statistics summary stat-cards.
 * Used by StatisticsOverviewPage and CompanyStatisticsPage.
 *
 * Props:
 *   count   – number of skeleton cards to render (default 3)
 *   mdCols  – 12-column grid width per card at "md" breakpoint (default 4)
 *   lines   – number of skeleton text lines inside each card (default 2)
 */

import React from 'react';
import { Box, Grid, Paper, Skeleton } from '@mui/material';

interface Props {
  /** How many skeleton cards to render. */
  count?: number;
  /** MUI Grid `md` width value (out of 12) per card. */
  mdCols?: number;
  /** How many text skeleton lines to draw inside each card (2 or 3). */
  lines?: number;
}

const StatCardsSkeleton: React.FC<Props> = ({ count = 3, mdCols = 4, lines = 2 }) => (
  <Grid container spacing={3} mb={4}>
    {Array.from({ length: count }, (_, i) => `stat-skeleton-${i}`).map((cardKey) => (
      <Grid item xs={12} sm={6} md={mdCols} key={cardKey}>
        <Paper sx={{ p: 2.5, display: 'flex', alignItems: 'center', gap: 2, height: '100%' }}>
          <Skeleton variant="circular" width={48} height={48} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="70%" sx={{ fontSize: '0.875rem' }} />
            <Skeleton variant="text" width="50%" sx={{ fontSize: '1.5rem' }} />
            {lines >= 3 && (
              <Skeleton variant="text" width="40%" sx={{ fontSize: '0.75rem' }} />
            )}
          </Box>
        </Paper>
      </Grid>
    ))}
  </Grid>
);

export default StatCardsSkeleton;
